import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GameScreensConfiguration, CommonStyle } from '@luckycart/xpn-types';

import { HomeScreen } from '../templates/screens/HomeScreen';
import { StyleContext } from '../utils/contexts/style.context';
import { apiServiceInstance } from '../utils/services/ApiService';
import { InformationContext, InformationType } from '../utils/contexts/information.context';


export const Preview: React.FunctionComponent = () => {
  const [informationContext, setInformationContext] = useState<InformationType>({});
  const { operationId } = useParams<{ operationId: string | undefined }>();
  const [
    configurations,
    setConfigurations,
  ] = useState<GameScreensConfiguration | null>(null);
  const [
    style,
    setStyle,
  ] = useState<CommonStyle | null>(null);

  useEffect(() => {
    if (typeof operationId === 'string') {
      apiServiceInstance.fetchPreviewData(operationId).then((fetchResult) => {
        setConfigurations(fetchResult.gameConfig.screens);
        setStyle(fetchResult.siteConfig.commons.style);
        setInformationContext({
          operation: fetchResult.operation,
          ticket: fetchResult.ticket,
          site: fetchResult.site,
        });
      });
    }
  }, [operationId]);

  return (
    <InformationContext.Provider value={{
      information: informationContext,
      setInformation: setInformationContext,
    }}>
      <StyleContext.Provider value={{
        setStyle,
        style,
      }}>
        {
          configurations !== null &&
          <HomeScreen config={configurations.home} />
        }
      </StyleContext.Provider>
    </InformationContext.Provider>
  );
};
